import {FILTERS_ARGS} from "../models/UsersConst";
import {transformQueryBoolean} from "@/util";

export class UsersFiltersDTO {

  constructor(queries = {}) {
    this.active_plan = queries[FILTERS_ARGS.ACTIVE_PLAN];
    this.is_active = transformQueryBoolean(queries[FILTERS_ARGS.IS_ACTIVE]);
    this.search = queries[FILTERS_ARGS.SEARCH];
  }
  
}
